var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(
      _vm.$route.path != '/MainMenu' &&
      _vm.$route.path != '/Login' &&
      _vm.$route.path != '/MeetingRoomScreen' &&
      _vm.$route.path != '/Order' &&
      _vm.$route.path != '/MyOrder' &&
      _vm.$route.path != '/AllBooking' &&
      !_vm.$route.path.startsWith('/CheckinMeeting')
    )?_c('NavBar'):_vm._e(),(_vm.$route.path == '/MainMenu')?_c('NavbarMain'):_vm._e(),_c('v-content',[(_vm.$route.path == '/MainMenu')?_c('div',{attrs:{"id":"grad"}},[_c('router-view')],1):_c('div',[_c('router-view')],1)]),(
      _vm.$route.path != '/MeetingRoomScreen' &&
      _vm.$route.path != '/Order' &&
      _vm.$route.path != '/MyOrder' &&
      _vm.$route.path != '/AllBooking' &&
      !_vm.$route.path.startsWith('/CheckinMeeting')
    )?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }